export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_AUTH = process.env.REACT_APP_BASIC_AUTH;
export const AUTH = process.env.REACT_API_AUTH;
